import React, { useContext, useEffect, useState } from 'react'
import PostCard from './PostCard/PostCard'
import postService from '../../../services/postService'
import PostLoading from '../../commonUIComponents/PostLoading'
import { Button, Grid, Paper, Typography } from '@mui/material'
import { useSnackbar } from 'notistack'
import { SearchBarContext } from '../../contexts/SearchBarContext'
import { useSearchParams } from 'react-router-dom'

const HomePage = () => {
  const { setCommunityId } = useContext(SearchBarContext)
  const [searchParams] = useSearchParams()
  const { enqueueSnackbar } = useSnackbar()
  const [page, setPage] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  const [isLastPage, setIsLastPage] = useState(false)
  const [posts, setPosts] = useState()
  const [loading, setLoading] = useState(true)

  const fetchPosts = () => {
    setLoading(true)
    postService.fetchPosts(page, pageSize, searchParams.get('communities'), searchParams.get('keyword'))
      .then(res => {
        if (posts && page > 0) {
          setPosts([...posts, ...res.posts])
        } else {
          setPosts(res.posts)
        }
        setIsLastPage(res.pagination.isLastPage)
      })
      .catch(err => enqueueSnackbar(err, { variant: 'error' }))
      .finally(() => setLoading(false))
  }

  const updateVote = (postId, userVote, totalVotes) => {
    const currentPosts = [...posts]
    currentPosts.forEach(post => {
      if (post.id === postId) {
        post.myVote = userVote
        post.votes = totalVotes
      }
    })
    setPosts(currentPosts)
  }

  useEffect(() => {
    setCommunityId(undefined)
    setPosts(null)
    fetchPosts()
  }, [page, searchParams])

  const paginationHandler = () => {
    setPage(page + 1)
  }

  return (
    <Grid container justifyContent="space-between">
      <Grid item xs>
        {posts?.map(post => <PostCard key={post.id} post={post} fetchPosts={fetchPosts} updateVote={updateVote}/>)}
        <PostLoading loading={loading}/>
        {!isLastPage && !loading
          ? <Button onClick={paginationHandler}>Show More</Button>
          : undefined}
      </Grid>
      {/* <Grid item xs sx={{ display: { xs: 'none', md: 'block' } }}> */}
      {/*  <Paper> */}
      {/*    <Typography>Community Info will be added here</Typography> */}
      {/*  </Paper> */}
      {/* </Grid> */}
    </Grid>
  )
}

export default HomePage
